import React from 'react'
import PropTypes from 'prop-types'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-light-svg-icons'

import {
  Box,
  Button,
  DashboardModule,
  Text,
} from '@domain-group/suit-theme'

import KeyContact from './KeyContact'

const KeyContacts = (props) => {
  const { publicationPayload } = props

  const {
    artworkContacts,
    bookingContacts,
    callbacks: { createOrEditKeyContact },
    hasArtworkContacts,
    hasBookingContacts,
    hasKeyContacts,
    loading,
  } = publicationPayload

  return (
    <DashboardModule title="Key Contacts" loading={loading}>
      <Box flexDirection="column">
        <DashboardModule.ScrollableSection>
          {hasArtworkContacts && (
            <>
              <Text color="faintGrey" fontSize="xsmall" marginTop="large" marginLeft="large">
                Artwork
              </Text>

              {artworkContacts.map((contact, index) => (
                <KeyContact
                  callbacks={{
                    createOrEditKeyContact: () => createOrEditKeyContact(contact),
                  }}
                  contact={contact}
                  isLast={index === artworkContacts.length - 1}
                  key={contact.id}
                />
              ))}
            </>
          )}

          {hasBookingContacts && (
            <>
              <Text color="faintGrey" fontSize="xsmall" marginTop="large" marginLeft="large">
                Booking
              </Text>

              {bookingContacts.map(contact => (
                <KeyContact
                  callbacks={{
                    createOrEditKeyContact: () => createOrEditKeyContact(contact),
                  }}
                  contact={contact}
                  key={contact.id}
                />
              ))}
            </>
          )}
        </DashboardModule.ScrollableSection>

        <DashboardModule.Footer
          boxProps={{
            borderTop: hasKeyContacts ? '1px solid' : 'none',
            justifyContent: 'flex-end',
          }}
        >
          <Button
            buttonStyle="secondaryEdit"
            icon={<FontAwesomeIcon icon={faPlus} />}
            onClick={() => createOrEditKeyContact()}
            size={['medium', 'small']}
            width={['100%', 'fit-content']}
          >
            Add Contact
          </Button>
        </DashboardModule.Footer>
      </Box>
    </DashboardModule>
  )
}

KeyContacts.propTypes = {
  publicationPayload: PropTypes.object.isRequired,
}

export default KeyContacts
